const host = window.location.origin

const serialize = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const Http = {
  get: async (path = '', data = null) => {
    try {
      const params = data ? `?${ serialize(data) }` : ""
      const url = host + path + params
      const response = await fetch(url)

      if (!response.ok) {
        throw new Error(`HTTP error, status: ${ response.status }`)
      }

      return response.json()
    } catch(e) {
      console.warn('Something is wrong: ', e)
    }
  },
  post: async (path = '', data = {}, method = 'POST') => {
    try {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      const params = JSON.stringify(data)
      const url = host + path
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: params,
      })

      if (!response.ok) {
        throw new Error(`HTTP error, status: ${ response.status }`)
      }

      return response.json()
    } catch(e) {
      console.warn('Something is wrong: ', e)
    }
  },
  patch: async (path = '', data = {}, method = 'PATCH') => {
    try {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      const params = JSON.stringify(data)
      const url = host + path
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        dataType: 'json',
        body: params,
      })

      return response.json()
    } catch(e) {
      console.warn('Something is wrong: ', e)
    }
  }
}
